import React from 'react';
import PropTypes from 'prop-types';

import { List } from 'immutable';
import { connect } from 'react-redux';

import {
    resultsConfigSelector,
    sortedAndFilteredProductsSelector,
    omittedBrandsSelector
} from 'ctm-selectors';

const withAvailableQuotes = (Component) => {
    class WithState extends React.PureComponent {

        render() {
            const { availableQuotes, ...rest } = this.props;
            return (
                <Component
                    availableQuotes={availableQuotes}
                    availableQuotesSize={availableQuotes ? availableQuotes.size : 0}
                    {...rest}
                />
            );
        }

    }

    WithState.propTypes = {
        availableQuotes: PropTypes.instanceOf(List)
    };

    return connect(mapStateToProps)(WithState);
};

// @See /packages/ctm-components/components/results/comparable_results/comparable_results.js
// also see availableProductResultsSelector
const mapStateToProps = (state) => {
    const omittedBrands = omittedBrandsSelector(state) || [];
    const isHideHighExcess = state.getIn(['page', 'isHideHighExcess']);
    const selectedExcessValue = resultsConfigSelector(state).getIn('filters.requestedExcess'.split('.'));
    // Get the sorted quotes based on store config
    const availableQuotes = sortedAndFilteredProductsSelector(state).filter((quote) => {
        const excess = quote.get('productMeta').get('excess');
        if (isHideHighExcess && excess > selectedExcessValue) {
            return false;
        }
        const providerCode = quote.getIn(['providerMeta', 'code']);
        return !omittedBrands.some((omittedProviderMeta) =>  omittedProviderMeta.get('code') === providerCode);
    });

    return {
        availableQuotes
    };
};

export { withAvailableQuotes };
